import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { esRutaPrivada } from '../lib/rutasPrivadas';

const PORTAL_ID = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
const SCRIPT_ID = 'hs-script-loader';

/**
 * Carga el script de tracking de HubSpot (una sola vez) y reporta cada cambio
 * de ruta, ya que React no recarga la página al navegar.
 * No carga ni reporta en las rutas del portal de copropietarios.
 * Llamar una sola vez dentro del router.
 */
export function useHubSpotPageView() {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (!PORTAL_ID) {
      console.warn('[SOHA] Falta REACT_APP_HUBSPOT_PORTAL_ID: el tracking de HubSpot está desactivado.');
      return;
    }
    if (esRutaPrivada(pathname)) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `https://js.hs-scripts.com/${PORTAL_ID}.js`;
    document.body.appendChild(script);
  }, [pathname]);

  useEffect(() => {
    if (!PORTAL_ID) return;
    // El script no se puede descargar una vez inyectado: si el visitante entra
    // por una ruta pública y luego pasa al portal, no debe reportarse la vista.
    if (esRutaPrivada(pathname)) return;

    window._hsq = window._hsq || [];
    window._hsq.push(['setPath', `${pathname}${location.search || ''}`]);
    window._hsq.push(['trackPageView']);
  }, [pathname, location.search]);
}

export default useHubSpotPageView;
